import { Injectable } from '@angular/core';
import { NavigationEnd, Params, Router, UrlTree } from '@angular/router';
import { filter } from 'rxjs/operators';

import { BaseUrlAndQueryParams } from '../models/base-url-and-query-params.model';

@Injectable()
export class RoutingStateService {
    private history: Array<string> = [];

    constructor(private router: Router) {}

    loadRouting(): void {
        this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(({ urlAfterRedirects }: NavigationEnd) => {
            this.history = [...this.history, urlAfterRedirects];
        });
    }

    getHistory(): string[] {
        return this.history;
    }

    getPreviousUrl(defaultRoute: string = '/', times: number = 1): string {
        return this.history[this.history.length - 1 - times] || defaultRoute;
    }

    getPreviousUrls(): string[] {
        return this.history;
    }

    getTimesCount(criteria: (url: string) => boolean): number {
        return this.getPreviousUrls().slice().reverse().findIndex(criteria);
    }

    getBaseUrlAndQueryParams(completeUrl: string): BaseUrlAndQueryParams {
        // parse previousUrl which might contain query parameters in order
        // to extract them and provide them to router navigate method
        const urlTree: UrlTree = this.router.parseUrl(completeUrl);
        // get base url without query parameters to use in router navigate method
        const baseUrl = completeUrl.indexOf('?') > -1 ? completeUrl.substring(0, completeUrl.indexOf('?')) : completeUrl;
        const queryParams: Params = urlTree.queryParams;
        return new BaseUrlAndQueryParams(baseUrl, queryParams);
    }

    navigateBack(defaultRoute?: string, times?: number): void {
        const previousUrl = this.getPreviousUrl(defaultRoute, times);
        const baseUrlAndQueryParams: BaseUrlAndQueryParams = this.getBaseUrlAndQueryParams(previousUrl);
        this.router.navigate([baseUrlAndQueryParams.baseUrl], { queryParams: baseUrlAndQueryParams.queryParams });
    }
}
